import React, { useRef, useEffect, cloneElement, useCallback } from "react";
const eventTypeMapping = {
    click: "onClick",
    focusin: "onFocus",
    focusout: "onFocus",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    touchstart: "onTouchStart",
    touchend: "onTouchEnd"
};
const OutsideClickListener = ({ children , onOutsideClick , focusEvent ="focusin" , mouseEvent ="click" , touchEvent ="touchend" ,  })=>{
    const node = useRef(null);
    const bubbledEventTarget = useRef(null);
    const mountedRef = useRef(false);
    /**
   * Prevents the bubbled event from getting triggered immediately
   * https://github.com/facebook/react/issues/20074
   */ useEffect(()=>{
        setTimeout(()=>{
            mountedRef.current = true;
        }, 0);
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const handleBubbledEvents = useCallback((type)=>{
        return (event)=>{
            bubbledEventTarget.current = event.target;
            const handler = children === null || children === void 0 ? void 0 : children.props[type];
            if (handler) handler(event);
        };
    }, [
        children === null || children === void 0 ? void 0 : children.props
    ]);
    const handleRef = useCallback((element)=>{
        node.current = element;
        const { ref  } = children;
        if (typeof ref === "function") ref(element);
        else if (ref) ref.current = element;
    }, [
        children
    ]);
    useEffect(()=>{
        var ref;
        var ref1;
        const nodeDocument = (ref1 = (ref = node.current) === null || ref === void 0 ? void 0 : ref.ownerDocument) !== null && ref1 !== void 0 ? ref1 : document;
        const handleEvents = (event)=>{
            if (!mountedRef.current) return;
            if (node.current && node.current.contains(event.target) || bubbledEventTarget.current === event.target || !nodeDocument.contains(event.target)) return;
            onOutsideClick(event);
        };
        nodeDocument.addEventListener(mouseEvent, handleEvents);
        nodeDocument.addEventListener(touchEvent, handleEvents);
        nodeDocument.addEventListener(focusEvent, handleEvents);
        return ()=>{
            nodeDocument.removeEventListener(mouseEvent, handleEvents);
            nodeDocument.removeEventListener(touchEvent, handleEvents);
            nodeDocument.removeEventListener(focusEvent, handleEvents);
        };
    }, [
        focusEvent,
        mouseEvent,
        onOutsideClick,
        touchEvent
    ]);
    const mappedMouseEvent = eventTypeMapping[mouseEvent];
    const mappedTouchEvent = eventTypeMapping[touchEvent];
    const mappedFocusEvent = eventTypeMapping[focusEvent];
    return React.Children.only(/*#__PURE__*/ cloneElement(children, {
        ref: handleRef,
        [mappedFocusEvent]: handleBubbledEvents(mappedFocusEvent),
        [mappedMouseEvent]: handleBubbledEvents(mappedMouseEvent),
        [mappedTouchEvent]: handleBubbledEvents(mappedTouchEvent)
    }));
};
export default OutsideClickListener;
